module.exports = __webpack_public_path__ + "static/media/sports01.cc0ec1cb.jpg";